export default __webpack_public_path__ + "static/media/onlymemes.24cb8e5c.png";